import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AToolTip from '../atoms/_atoms.tool-tip';

export default class MProductDetailListItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = { showTooltip: 'none' };

		this.handleHoverEventListener = this.handleHoverEventListener.bind(this);
		this.handleHideTooltip = this.handleHideTooltip.bind(this);
	}

	handleHoverEventListener() {
		this.setState({ showTooltip: 'flex' });
	}

	handleHideTooltip() {
		this.setState({ showTooltip: 'none' });
	}

	render() {
		let tip;
		if (this.props.tooltip) {
			tip = <AToolTip text={this.props.tooltip} position="bottom-right" />;
		}

		return (
			<li
				onMouseLeave={this.handleHideTooltip}
				onMouseEnter={this.handleHoverEventListener}
				className="m-product-detail-list"
			>
				<article
					className="a-tooltip-container"
					style={{ display: this.state.showTooltip }}
				>
					{tip}
				</article>
				<p className="bold m-product-detail-list--label">
					<FormattedMessage id={this.props.label} />:
				</p>
				<p className="m-product-detail-list--value-label">{this.props.value}</p>
			</li>
		);
	}
}

MProductDetailListItem.propTypes = {
	label: PropTypes.string,
	value: PropTypes.string,
	tooltip: PropTypes.string,
};

MProductDetailListItem.defaultProps = {
	label: '',
	value: '',
	tooltip: '',
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.product-detail-list-item.js